<div class="main-table">
    <div class="main-table-toolbar">
        <div class="main-toolbar-container">
            <div class="main-toolbar-add">
                <button
                    mat-stroked-button
                    (click)="add()"
                    matTooltip="{{ 'new_record_hint' | transloco }}"
                >
                    <mat-icon>add</mat-icon>
                    {{ "new_record" | transloco }}
                </button>
            </div>
            <div class="main-toolbar-spacer"></div>
            <div class="main-toolbar-filter-container">
                <div class="main-toolbar-filter">
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'Name'"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="filterLen"
                            (onKeyUpChange)="setNameFilter($event)"
                        />
                    </div>
                    <div class="filter-item">
                        <pixl-free-filter-input
                            [label]="'URL'"
                            [matIcon]="'search'"
                            [hint]="getSearchFilterHint()"
                            [minLength]="filterLen"
                            (onKeyUpChange)="setUrlFilter($event)"
                        />
                    </div>
                </div>
            </div>
            <div class="main-toolbar-spacer-right"></div>
        </div>
        <div class="table-header-overlay"></div>
    </div>

    <div class="table-container mat-elevation-z4">
        <table
            mat-table
            [dataSource]="(consumers$ | async) || []"
            [trackBy]="trackById"
        >
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "actions" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let consumer"
                >
                    <button
                        [class.btn-success]="coloredButtonsEnabled()"
                        mat-icon-button
                        aria-label="Edit"
                        (click)="edit(consumer)"
                        matTooltip="{ 'edit_record_hint' | transloco }}"
                    >
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button
                        [class.btn-danger]="coloredButtonsEnabled()"
                        mat-icon-button
                        color="warn"
                        aria-label="Delete"
                        (click)="delete(consumer)"
                        matTooltip="{{ 'delete_record_hint' | transloco }}"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="id">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >ID</th>
                <td
                    mat-cell
                    *matCellDef="let consumer"
                >
                    {{ consumer.id }}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "name" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let consumer"
                >
                    {{ consumer.name }}
                </td>
            </ng-container>

            <ng-container matColumnDef="url">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "url" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let consumer"
                >
                    {{ consumer.url }}
                </td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th
                    mat-header-cell
                    *matHeaderCellDef
                >{{ "description" | transloco }}</th>
                <td
                    mat-cell
                    *matCellDef="let consumer"
                >
                    {{ consumer.description }}
                </td>
            </ng-container>

            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns"
                [class.selected-row]="currentSelectedRow() === row.id"
            ></tr>
        </table>
        <mat-paginator
            [length]="totalItems || 0"
            [pageSize]="pageSize"
            [pageSizeOptions]="[25, 50, 100]"
        ></mat-paginator>
    </div>
</div>